import { AxiosPromise } from 'axios';
import api from './api';

const loginEmail = (data: unknown): AxiosPromise => api.post('/customers/login', data);

const recoverPassword = (data: unknown): AxiosPromise => api.post('/customers/reset', data);

const newPassword = (data: unknown): AxiosPromise => api.post('/customers/login/firstAcess', data);

export { loginEmail, recoverPassword, newPassword };
